import { Button } from '@mui/material'
import { LinkWithArrow } from '@/components'
import type { ButtonProps } from '@mui/material/Button'

interface ActionButtonProps {
  onClick: () => void
  label: string
}

interface ActionLinkProps {
  onClick: () => void
  label: string
}

interface ActionTriggersProps {
  mainActionButton?: ActionButtonProps
  secondaryActionButton?: ActionButtonProps
  actionLink?: ActionLinkProps
  color: ButtonProps['color']
}

export const ActionTriggers = ({
  mainActionButton,
  secondaryActionButton,
  actionLink,
  color
}: ActionTriggersProps) => {
  return (
    <>
      {(mainActionButton || secondaryActionButton) && (
        <>
          {secondaryActionButton && (
            <Button
              color={color}
              onClick={secondaryActionButton.onClick}
              fullWidth
              sx={{ lineHeight: 1.15 }}
            >
              {secondaryActionButton.label}
            </Button>
          )}

          {mainActionButton && (
            <Button
              color={color}
              variant="outlined"
              onClick={mainActionButton.onClick}
              fullWidth
              sx={{ lineHeight: 1.15 }}
            >
              {mainActionButton.label}
            </Button>
          )}
        </>
      )}
      {actionLink && (
        <LinkWithArrow onClick={actionLink.onClick} label={actionLink.label} />
      )}
    </>
  )
}
